import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { FiscalDeviceQuery, FiscalDeviceQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(FiscalDeviceQuery)
@Wrapper(FiscalDeviceQueryHandlerBase)
export class FiscalDeviceQueryHandler {
    public constructor(
        http: Http,
    ) { }
}
